import { useCallback, useEffect } from 'react';

const useCatchLeave = (condition: boolean) => {
  /**
   * report 사용여부, 변경 후 저장 안하고 페이지 나갈 경우, 이벤트
   * @param ev
   */
  const leave = useCallback((ev: any) => {
    ev.preventDefault();
    return (ev.returnValue = '사이트를 새로고침하시겠습니까? \n\r변경사항이 저장되지 않을 수 있습니다.');
  }, []);

  /**
   * 변경 안하고 나갈 경우(탭, 창을 닫음) 이벤트 감지
   */
  useEffect(() => {
    if (condition) {
      window.removeEventListener('beforeunload', leave);
      window.addEventListener('beforeunload', leave);
    }
    return () => {
      window.removeEventListener('beforeunload', leave);
    };
  }, [leave, condition]);
};
export default useCatchLeave;
